export default __webpack_public_path__ + "static/media/HPLogo-LoadingPage.e9ca6c01.svg";